import { combineReducers } from "redux";
import { notesConstants } from "../actions/detailsDocument/notes";

function noteStatus(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case notesConstants.MODIFY_NOTE_NEW_START:
    return {
      ...defaultState,
      statusModify: {
        error: false,
        loading: true,
        ended: false,
        id: payload.id
      }
    };
  case notesConstants.MODIFY_NOTE_NEW_SUCCESS:
    return {
      ...defaultState,
      statusModify: {
        error: false,
        loading: false,
        ended: true,
        id: payload.id
      }
    };
  case notesConstants.MODIFY_NOTE_NEW_ERROR:
    return {
      ...defaultState,
      statusModify: {
        error: true,
        loading: false,
        ended: false,
        id: payload.id
      }
    };
  case notesConstants.DELETE_NOTE_START:
    return {
      ...defaultState,
      statusRemove: {
        error: false,
        loading: true,
        ended: false,
        id: payload.noteID
      }
    };
  case notesConstants.DELETE_NOTE_SUCCESS:
    return {
      ...defaultState,
      statusRemove: {
        error: false,
        loading: false,
        ended: true,
        id: payload.noteID
      }
    };
  case notesConstants.DELETE_NOTE_ERROR:
    return {
      ...defaultState,
      statusRemove: {
        error: true,
        loading: false,
        ended: false,
        id: payload.noteID
      }
    };
  case notesConstants.CREATE_NOTE_START:
    return {
      ...defaultState,
      statusNew: {
        error: false,
        loading: true,
        ended: false
      }
    };
  case notesConstants.CREATE_NOTE_SUCCESS:
    return {
      ...defaultState,
      statusNew: {
        error: false,
        loading: false,
        ended: true
      }
    };
  case notesConstants.CREATE_NOTE_ERROR:
    return {
      ...defaultState,
      statusNew: {
        error: true,
        loading: false,
        ended: false
      }
    };
  case notesConstants.RESET_NOTE:
  default:
    return {
      statusModify: {
        error: false,
        loading: false,
        ended: false
      },
      statusNew: {
        error: false,
        loading: false,
        ended: false
      },
      statusRemove: {
        error: false,
        loading: false,
        ended: false
      }
    };
  }
}

const notes = combineReducers({ status: noteStatus });

export default notes;
